import * as _ from 'lodash';
import {Pipe, PipeTransform} from '@angular/core';

@Pipe({
    name: 'dataFilterForCa'
})
export class DataFilterPipeForCA implements PipeTransform {

    transform(array: any[], query: string): any {
        if (query) {
            return _.filter(array, row => row.activity.toLowerCase().indexOf(query.toLowerCase()) > -1);
        }
        return array;
    }
}
  


// WEBPACK FOOTER //
// D:/Sonali/JCCBViewOnlyProject/ViewOnlyJCCBfrontend19112022/InternetBanking6.3frontend/src/app/customer-activity/data-filter-for-ca.pipe.ts